<br />
<ng-container *ngIf="visible">
  <div>
    <mat-card>
      <loading class="spinner__loading" *ngIf="isLoading"
        >{{ isLoading }} Cargando...</loading
      >
    </mat-card>
  </div>

  <div>
    <mat-card id="card" style="text-align: center" class=".modal-panel">
      <br />
      <mat-card-title>
        <pichincha-typography
          variant="prelo"
          color="bp-primary-blue-900"
          weight="200"
          size="18px"
          lineHeight="20px"
          spacing="1.5"
          category="h1"
          tabIndexElement="2"
          align="center"
        >
          Criterios de búsqueda
        </pichincha-typography>
      </mat-card-title>
      <mat-card-content>
        <div *ngIf="loadContent">
          <mat-card-content>
            <form
              [formGroup]="formGroup"
              (ngSubmit)="onSubmit()"
              (reset)="resetForm()"
            >
              <mat-form-field style="margin-right: 1rem; width: 15%">
                <input
                  matInput
                  [matDatepicker]="myDatepicker"
                  formControlName="fecha"
                  placeholder="fecha inicio"
                />

                <mat-datepicker-toggle matSuffix [for]="myDatepicker">
                </mat-datepicker-toggle>

                <mat-datepicker #myDatepicker></mat-datepicker>
                <mat-error *ngIf="form.get('fecha').hasError('required')">
                  Ingrese un valor de fecha inicio.
                </mat-error>
              </mat-form-field>
              <br />
              <mat-form-field style="margin-right: 2rem">
                <input
                  matInput
                  [matDatepicker]="myDatepickerfin"
                  formControlName="fechafin"
                  placeholder="fecha fin"
                />

                <mat-datepicker-toggle matSuffix [for]="myDatepickerfin">
                </mat-datepicker-toggle>
                <mat-datepicker #myDatepickerfin></mat-datepicker>
                <mat-error *ngIf="form.get('fechafin').hasError('required')">
                  Ingrese un valor de fecha fin.
                </mat-error>
                <mat-error *ngIf="formGroup.hasError('rangeExceeded')">
                  The date range cannot exceed 30 days.
                </mat-error>
              </mat-form-field>

              <mat-form-field style="margin-right: 2rem">
                <input
                  matInput
                  placeholder="ani"
                  formControlName="ani"
                  (keypress)="allowOnlyNumbersAndPlus($event)"
                  maxlength="13"
                />
              </mat-form-field>

              <mat-form-field style="margin-right: 2rem">
                <input
                  matInput
                  placeholder="dnis"
                  formControlName="dnis"
                  (keypress)="allowOnlyNumbersAndPlus($event)"
                  maxlength="13"
                />
              </mat-form-field>

              <mat-form-field style="margin-right: 2rem">
                <input
                  matInput
                  placeholder="identificación"
                  formControlName="identificacion"
                  (keypress)="allowOnlyNumbersAndPlus($event)"
                  maxlength="13"
                />
              </mat-form-field>

              <br />
              <ng-multiselect-dropdown
                style="margin-right: 1rem; width: 37%"
                #multiSelect
                [placeholder]="'Seleccione Dirección'"
                [data]="selectedDireccion"
                [formControl]="f.direccion"
                [settings]="settingsDirs"
                [class.is-invalid]="
                  f?.direccion.errors?.required && f?.direccion.touched
                "
                (onFilterChange)="onFilterChangeDirs($event)"
                (onDropDownClose)="onDropDownCloseDirs($event)"
                (onSelect)="onItemSelectDirs($event)"
                (onDeSelect)="onDeSelectDirs($event)"
                (onSelectAll)="onSelectAllDirs($event)"
                (onDeSelectAll)="onDeSelectAllDirs($event)"
              >
              </ng-multiselect-dropdown>

              <ng-multiselect-dropdown
                #multiSelect
                [placeholder]="'Seleccione Campaña'"
                [data]="selectedCamps"
                [formControl]="f.campania"
                [settings]="settingsCamps"
                [class.is-invalid]="
                  f?.campania.errors?.required && f?.campania.touched
                "
                (onFilterChange)="onFilterChangeCamps($event)"
                (onDropDownClose)="onDropDownCloseCamps($event)"
                (onSelect)="onItemSelectCamps($event)"
                (onDeSelect)="onDeSelectCamps($event)"
                (onSelectAll)="onSelectAllCamps($event)"
                (onDeSelectAll)="onDeSelectAllCamps($event)"
              >
              </ng-multiselect-dropdown>
              <br />
              <ng-multiselect-dropdown
                #multiSelect
                [placeholder]="'Seleccione Lista de Contacto'"
                [data]="selectedCL"
                [formControl]="f.contactlist"
                [settings]="settingsCLs"
                [class.is-invalid]="
                  f?.contactlist.errors?.required && f?.contactlist.touched
                "
                (onFilterChange)="onFilterChangeCLs($event)"
                (onDropDownClose)="onDropDownCloseCLs($event)"
                (onSelect)="onItemSelectCLs($event)"
                (onDeSelect)="onDeSelectCLs($event)"
                (onSelectAll)="onSelectAllCLs($event)"
                (onDeSelectAll)="onDeSelectAllCLs($event)"
              >
              </ng-multiselect-dropdown>

              <br />
              <ng-multiselect-dropdown
                #multiSelect
                [placeholder]="'Seleccione Usuarios'"
                [data]="selectedUsuarios"
                [formControl]="f.usuarios"
                [settings]="settingsUsers"
                [class.is-invalid]="
                  f?.usuarios?.errors?.required && f?.usuarios?.touched
                "
                (onFilterChange)="onFilterChangeUsers($event)"
                (onDropDownClose)="onDropDownCloseUsers($event)"
                (onSelect)="onItemSelectUsers($event)"
                (onDeSelect)="onDeSelectUsers($event)"
                (onSelectAll)="onSelectAllUsers($event)"
                (onDeSelectAll)="onDeSelectAllUsers($event)"
              >
              </ng-multiselect-dropdown>

              <span
                *ngIf="f?.usuarios?.errors?.required && f?.usuarios?.touched"
                style="color: red"
              >
                Usuario es requerido
              </span>
              <br />

              <ng-multiselect-dropdown
                style="margin-right: 1rem; width: 10%"
                #multiSelectC
                [placeholder]="'Seleccione Colas'"
                [data]="selectedColas"
                [formControl]="f.colas"
                [settings]="settingsQueues"
                [class.is-invalid]="
                  f?.colas?.errors?.required && f?.colas?.touched
                "
                (onFilterChange)="onFilterChangeQueues($event)"
                (onDropDownClose)="onDropDownCloseQueues($event)"
                (onSelect)="onItemSelectQueues($event)"
                (onDeSelect)="onDeSelectQueues($event)"
                (onSelectAll)="onSelectAllQueues($event)"
                (onDeSelectAll)="onDeSelectAllQueues($event)"
              >
              </ng-multiselect-dropdown>

              <span
                *ngIf="f?.colas?.errors?.required && f?.colas?.touched"
                style="color: red"
              >
                Cola es requerida
              </span>
              <br />
              <br />
              <mat-dialog-actions align="center">
                <pichincha-button
                  variant="complementary"
                  label="Consultar"
                  (click)="onSubmit()"
                  [disabled]="formGroup.invalid"
                  iconName="search"
                ></pichincha-button>
              </mat-dialog-actions>
            </form>
          </mat-card-content>
        </div>

        <div class="edit-course-form">
          <h2 mat-dialog-title>{{ description }}</h2>
          <mat-dialog-content [formGroup]="form">
            <br />
          </mat-dialog-content>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-container>

<div class="alert" [class.visible]="isVisible">
  <pichincha-typography
    variant="prelo-slab"
    color="bp-primary-blue500"
    weight="200"
    size="15px"
    lineHeight="15px"
    spacing="1"
    category="text"
    tabIndexElement="2"
    align="center"
  >
    Intervalo, no es permitido
  </pichincha-typography>

  <pichincha-alerts
    type="information"
    alertTitle="Atencion"
    description="Intervalo, no es permitido"
    hasIcon="false"
    show="true"
    autoClose="true"
    closeTime="5000"
    loading="false"
  >
  </pichincha-alerts>
</div>
<div
  style="
    padding: 1em;
    margin: 2rem;
    width: 98%;
    background-color: rgba(255, 255, 255, 0.2);
  "
>
  <pichincha-button
    variant="complementary"
    label="Limpiar lista"
    (click)="emptyList()"
    iconName="cancel"
  ></pichincha-button>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="tableDataSource" aria-label="Resultado">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>Id</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>

      <!-- IdConversacion Column -->
      <ng-container matColumnDef="conversationId">
        <th mat-header-cell *matHeaderCellDef>IdConversacion</th>
        <td mat-cell *matCellDef="let row">{{ row.conversationId }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="namefile">
        <th mat-header-cell *matHeaderCellDef>NombreArchivo</th>
        <td mat-cell *matCellDef="let row">{{ row.namefile }}</td>
      </ng-container>

      <!-- NombreCliente Column -->
      <ng-container matColumnDef="customerFullName">
        <th mat-header-cell *matHeaderCellDef>NombreCliente</th>
        <td mat-cell *matCellDef="let row" [style.color]="row.customerFullName">
          <a>{{ row.customerFullName }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="queueName">
        <th mat-header-cell *matHeaderCellDef>NombreCola</th>
        <td mat-cell *matCellDef="let row" [style.color]="row.queueName">
          <a>{{ row.queueName }}</a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="selection.toggle(row)"
      ></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50]"
      showFirstLastButtons
    ></mat-paginator>
  </div>

  <ng-container *ngIf="visibleDown">
    <mat-card>
      <mat-card-content>
        <div class="file" [class.visible]="down_enabled">
          <div id="content" style="display: none">
            <mat-checkbox [checked]="uncheckmp3">
              Descargar como .MP3
            </mat-checkbox>
          </div>
          <pichincha-typography
            variant="prelo"
            weight="500"
            size="16px"
            line-height="24px"
          >
            <p>{{ slides.name }}</p>
          </pichincha-typography>

          <pichincha-button
            variant="primary"
            label="Descargar archivo"
            (click)="download(slides)"
            iconName="backup"
          ></pichincha-button>
        </div>
        <br />
        <mat-progress-bar
          *ngIf="isLoadingIndeterminate"
          mode="indeterminate"
        ></mat-progress-bar>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>

<div class="alert" [class.visible]="isVisible">
  <pichincha-typography
    variant="prelo-slab"
    color="bp-primary-blue500"
    weight="200"
    size="15px"
    lineHeight="15px"
    spacing="1"
    category="text"
    tabIndexElement="2"
    align="center"
  >
    No hay archivos para descargar
  </pichincha-typography>

  <pichincha-alerts
    type="information"
    alertTitle="Atencion"
    description="No hay archivos para descargar"
    hasIcon="false"
    show="true"
    autoClose="true"
    closeTime="5000"
    loading="false"
  >
  </pichincha-alerts>
</div>
<app-date-range-picker
  (dateValidationMessage)="handleDateValidationMessage($event)"
></app-date-range-picker>

<div *ngIf="validationMessage" style="color: red">
  {{ validationMessage }}
</div>

<div class="alert" [class.visible]="isVisible1">
  <pichincha-typography
    variant="prelo-slab"
    color="bp-primary-blue500"
    weight="200"
    size="15px"
    lineHeight="15px"
    spacing="1"
    category="text"
    tabIndexElement="2"
    align="center"
  >
    Intervalo, no es permitido
  </pichincha-typography>

  <pichincha-alerts
    type="information"
    alertTitle="Atencion"
    description="Intervalo, no es permitido"
    hasIcon="false"
    show="true"
    autoClose="true"
    closeTime="5000"
    loading="false"
  >
  </pichincha-alerts>
</div>
